import { TrendingUp, Users, Trophy, Zap } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

interface LeaderboardStatsProps {
  volume24h: number;
  activeTraders: number;
  topProfit: number;
  totalTrades: number;
  isLoading?: boolean;
}

export function LeaderboardStats({ volume24h, activeTraders, topProfit, totalTrades, isLoading }: LeaderboardStatsProps) {
  const formatUSD = (value: number) => {
    if (value >= 1000000) return `$${(value / 1000000).toFixed(2)}M`;
    if (value >= 1000) return `$${(value / 1000).toFixed(1)}K`;
    return `$${value.toFixed(2)}`;
  };

  const stats = [
    { icon: TrendingUp, label: "Volume (24h)", value: formatUSD(volume24h), color: "text-success" },
    { icon: Users, label: "Active Traders", value: activeTraders.toLocaleString(), color: "text-primary" },
    { icon: Trophy, label: "Top Profit", value: formatUSD(topProfit), color: "text-warning" },
    { icon: Zap, label: "Total Trades", value: totalTrades.toLocaleString(), color: "text-accent" },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
      {stats.map((stat, i) => (
        <div
          key={stat.label}
          className="relative p-4 rounded-xl bg-card border border-border overflow-hidden group hover:border-primary/30 transition-colors"
        >
          <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
          <stat.icon className={`w-5 h-5 ${stat.color} mb-2`} />
          {isLoading ? (
            <Skeleton className="h-7 w-20 mb-1" />
          ) : (
            <p className="text-lg sm:text-2xl font-mono font-bold text-foreground">{stat.value}</p>
          )}
          <p className="text-xs sm:text-sm text-muted-foreground">{stat.label}</p>
        </div>
      ))}
    </div>
  );
}
